const Indent3 = {
    elemName: '字下げ三',
    type: 'block',
    doc: '三文字分字下げがある箇所を囲むブロックです',
    example: '％字下げ三\nこの部分が字下げされます\n％',
    textTemplate: '{{$1}}',
    htmlTemplate: `<div {{{$htmlId}}} class="Indent3 {{$classes}}">{{{$1}}}</div>`,
    xmlTemplate: `<div rend="indent(-3)" {{{$xmlId}}} {{$xmlSubtypes}}>{{{$1}}}</div>`,
    docxTemplate: `<w:p>{{{$1}}}</w:p>`
};
export default Indent3;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5kZW50My5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb252ZXJ0ZXIvYmxvY2tfcnVsZXMvSW5kZW50My50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLE9BQU8sR0FBbUI7SUFDL0IsUUFBUSxFQUFFLE1BQU07SUFDaEIsSUFBSSxFQUFFLE9BQU87SUFDYixHQUFHLEVBQUUsdUJBQXVCO0lBQzVCLE9BQU8sRUFBRSx3QkFBd0I7SUFDakMsWUFBWSxFQUFFLFFBQVE7SUFDdEIsWUFBWSxFQUFFLGdFQUFnRTtJQUM5RSxXQUFXLEVBQUUscUVBQXFFO0lBQ2xGLFlBQVksRUFBRSxxQkFBcUI7Q0FDbkMsQ0FBQztBQUVGLGVBQWUsT0FBTyxDQUFDIn0=